"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsService = void 0;
class AccountsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of accounts.
     * @param page 'Page number (default 1)
     * @param count Number of results per page (default 10)
     * @param q Query to filter the results on
     * @returns AccountsResponse
     * @throws ApiError
     */
    getAccounts(page, count, q) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/accounts',
            query: {
                'page': page,
                'count': count,
                'q': q,
            },
        });
    }
    /**
     * Create a new account.
     * @param requestBody
     * @returns AccountResponse
     * @throws ApiError
     */
    createAccount(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/accounts',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Return a list of account industries.
     * @returns AccountsIndustries
     * @throws ApiError
     */
    getAccountsIndustries() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/accounts/industries',
        });
    }
    /**
     * Returns specific account details by id.
     * @param id Identifier (uuid format)
     * @returns AccountResponse
     * @throws ApiError
     */
    getAccount(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/accounts/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update an existing account.
     * @param id
     * @param requestBody
     * @returns AccountResponse
     * @throws ApiError
     */
    updateAccount(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/accounts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete an existing account.
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAccount(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/accounts/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns account details by account fields
     * @param requestBody
     * @returns AccountResponse
     * @throws ApiError
     */
    getAccountBy(requestBody) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/accounts-by',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generates a new account API KEY.
     * @param id
     * @returns AccountResponse
     * @throws ApiError
     */
    generateApiKey(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/accounts/{id}/generate-api-key',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get array of advertiser for the specified account.
     * @param accountId
     * @returns AdvertisersResponse
     * @throws ApiError
     */
    getAdvertisers(accountId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/accounts/{accountId}/advertisers',
            path: {
                'accountId': accountId,
            },
        });
    }
    /**
     * Create a advertiser to an account
     * @param accountId
     * @param requestBody
     * @returns AdvertiserResponse
     * @throws ApiError
     */
    createAdvertiser(accountId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/accounts/{accountId}/advertisers',
            path: {
                'accountId': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.AccountsService = AccountsService;
